import { Component } from 'react';
class WindowPopUp extends Component {
    constructor(props) {
        super(props);
        this.externalWindow = null;
    }

    componentDidMount() {

        // Create a new window, with given URL
        this.externalWindow = window.open(this.props.url, '', 'width=600,height=400,left=200,top=200');
        // set given title
        this.externalWindow.document.title = this.props.title;

        // update the state in the parent component if the user closes the 
        // new window
        this.externalWindow.addEventListener('beforeunload', () => {
            this.props.close();
        });
    }

    componentWillUnmount() {
        // This will fire when this.state.open in the parent component becomes false
        // So we tidy up by just closing the window
        this.externalWindow.close();
    }

    render() {
        return null;
    }
}
export default WindowPopUp;


// WEBPACK FOOTER //
// ./src/app/components/WindowPopUp.js